import { IState } from '../types';
import { TBookSettings } from '../../../common/rest/endlessBook/endlessBookRest';

export const isBookCreating = (state: IState, audioId: number): boolean =>
	!!state.books.creating[audioId];

export const isBookRegenerating = (state: IState, bookId: number): boolean =>
	!!state.books.regenerating[bookId];

export const getBookReloadKey = (state: IState, bookId: number): number =>
	state.books.reloadKey[bookId] || 0;

export const getBookSettings = (state: IState, bookId: number): TBookSettings | undefined =>
	state.books.settings[bookId];

export const getBookHost = (state: IState): string | null =>
	state.books.bookHost;

export const isBookHostFailed = (state: IState): boolean =>
	state.books.bookHostFailed;
